// extracted by mini-css-extract-plugin
export default {"root":"adc__root--E_kZh","bid-at-county-button":"adc__bid-at-county-button--SvoYy","real-auction":"adc__real-auction--aSRVG","real-auction-list":"adc__real-auction-list--iDFOP"};